// BottomTabBar — mobile only. Port of design/v3/Chrome.jsx.

import { NavLink, useLocation } from 'react-router-dom';
import { Icon } from '../primitives';

const TABS = [
  { id: 'ops', label: '운영', icon: 'store', to: '/ops' },
  { id: 'inventory', label: '재고', icon: 'package', to: '/inventory' },
  { id: 'schedule', label: '일정', icon: 'calendar', to: '/schedule' },
  { id: 'settings', label: '설정', icon: 'settings', to: '/settings' },
];

export function BottomTabBar() {
  const location = useLocation();
  const activeId =
    TABS.find((t) => location.pathname.startsWith(t.to))?.id ?? 'ops';
  return (
    <nav
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        height: 'calc(var(--bottom-nav-h) + env(safe-area-inset-bottom, 0px))',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        borderTop: '1px solid var(--border-weak)',
        background: 'var(--bg-surface)',
        flexShrink: 0,
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      {TABS.map((t) => {
        const active = t.id === activeId;
        return (
          <NavLink
            key={t.id}
            to={t.to}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              fontSize: 11,
              fontWeight: active ? 600 : 500,
              color: active ? 'var(--primary-strong)' : 'var(--fg-3)',
              position: 'relative',
              textDecoration: 'none',
              minWidth: 0,
              touchAction: 'manipulation',
            }}
          >
            {active && (
              <span
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '28%',
                  right: '28%',
                  height: 2,
                  background: 'var(--primary-strong)',
                  borderRadius: '0 0 3px 3px',
                }}
              />
            )}
            <Icon
              name={t.icon}
              size={20}
              color={active ? 'var(--primary-strong)' : 'var(--fg-3)'}
              strokeWidth={active ? 2 : 1.75}
            />
            {t.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
